import { useContext, useEffect } from "react";
import { Card, CardBody, CardHeader, Form, FormGroup } from "reactstrap";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { isEmpty } from "lodash";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import ErrorMessage from "./../../../helpers/ErrorMessage/ErrorMessage";
import Button from "./../../../components/Button/Button";
import PageHeader from "./../../../components/PageHeader/PageHeader";
import { Block } from "./../../../components/Block/Block";
import { editWebServiceProfitValidation } from "../../../utils/validation/validation";
import { Col, Row } from "./../../../components/Grid/Grid";
import { webServiceProfitAdminContext } from "../../../context/AdminContext/WebServiceProfitAdminContext/WebServiceProfitAdminContext";

const WebServiceProfitAdmin = () => {
  const loader = useSelector((state) => state.loader);

  const {
    webServiceProfit,
    handleGetWebServiceProfit,
    handleEditWebServiceProfit,
  } = useContext(webServiceProfitAdminContext);

  // Validation
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(editWebServiceProfitValidation),
  });

  useEffect(() => {
    handleGetWebServiceProfit();
  }, []);

  useEffect(() => {
    if (!isEmpty(webServiceProfit)) {
      setValue("snappTrip.discount", webServiceProfit?.snappTrip?.discount);
      setValue(
        "snappTrip.profitPercentage",
        webServiceProfit?.snappTrip?.profitPercentage
      );
      setValue("charter724.discount", webServiceProfit?.charter724?.discount);
      setValue(
        "charter724.profitPercentage",
        webServiceProfit?.charter724?.profitPercentage
      );
    }
  }, [webServiceProfit]);

  return (
    <>
      <SiteTitle title="سود وب سرویس ها" />

      <PageHeader title="سود وب سرویس ها" description="" />

      <Card>
        <CardBody>
          <Block>
            <Form
              className="is-alter"
              onSubmit={handleSubmit(handleEditWebServiceProfit)}
            >
              <Row>
                <Col size="12" lg="6">
                  <Card className="mb-3">
                    <CardHeader>اسنپ تریپ</CardHeader>
                    <CardBody>
                      <Row>
                        <Col size="12" sm="6">
                          <FormGroup>
                            <label
                              className="form-label"
                              htmlFor="snappTrip.profitPercentage"
                            >
                              میزان درصد سود اسنپ تریپ
                            </label>
                            <div className="form-control-wrap">
                              <input
                                type="number"
                                placeholder="میزان درصد سود اسنپ تریپ را وارد نمایید"
                                className="form-control-lg form-control"
                                min={0}
                                {...register("snappTrip.profitPercentage")}
                              />
                              <ErrorMessage
                                message={
                                  errors.snappTrip?.profitPercentage?.message
                                }
                              />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col size="12" sm="6">
                          <FormGroup>
                            <label
                              className="form-label"
                              htmlFor="snappTrip.discount"
                            >
                              میزان تخفیف اسنپ تریپ
                            </label>
                            <div className="form-control-wrap">
                              <input
                                type="number"
                                placeholder="میزان تخفیف اسنپ تریپ را وارد نمایید"
                                className="form-control-lg form-control"
                                min={0}
                                {...register("snappTrip.discount")}
                              />
                              <ErrorMessage
                                message={errors.snappTrip?.discount?.message}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col size="12" lg="6">
                  <Card className="mb-3">
                    <CardHeader>چارتر 724</CardHeader>
                    <CardBody>
                      <Row>
                        <Col size="12" sm="6">
                          <FormGroup>
                            <label
                              className="form-label"
                              htmlFor="charter724.profitPercentage"
                            >
                              میزان درصد سود چارتر 724
                            </label>
                            <div className="form-control-wrap">
                              <input
                                type="number"
                                placeholder="میزان درصد سود چارتر 724 را وارد نمایید"
                                className="form-control-lg form-control"
                                min={0}
                                {...register("charter724.profitPercentage")}
                              />
                              <ErrorMessage
                                message={
                                  errors.charter724?.profitPercentage?.message
                                }
                              />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col size="12" sm="6">
                          <FormGroup>
                            <label
                              className="form-label"
                              htmlFor="charter724.discount"
                            >
                              میزان تخفیف چارتر 724
                            </label>
                            <div className="form-control-wrap">
                              <input
                                type="number"
                                placeholder="میزان تخفیف چارتر 724 را وارد نمایید"
                                className="form-control-lg form-control"
                                min={0}
                                {...register("charter724.discount")}
                              />
                              <ErrorMessage
                                message={errors.charter724?.discount?.message}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <ul className="align-center flex-wrap flex-sm-nowrap">
                <li>
                  <Button
                    color="primary"
                    size="lg"
                    type="submit"
                    loading={loader}
                  >
                    ویرایش تنظیمات
                  </Button>
                </li>
              </ul>
            </Form>
          </Block>
        </CardBody>
      </Card>
    </>
  );
};

export default WebServiceProfitAdmin;
